import useDateFormatters from "@hooks/useDateFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { IssueDateBadgeProps } from "./IssueDateBadge.types"

const icon = faIcon({ name: "calendar-lines-pen", style: "regular" })

export default function IssueDateBadge(props: IssueDateBadgeProps) {
    const { date, size = "md", label = "Issued" } = props

    const { formatDate } = useDateFormatters()

    const formatted = formatDate(date)

    if (!formatted) {
        return null
    }

    // e.g. "Issued\non January 1, 2025".
    const tooltip = `${label}\non ${formatDate(date, "long")}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {formatted}
        </Badge>
    )
}
